<template>
  <div
    class="c-progress-step-bar"
    :class="theme ? `c-progress-step-bar--${theme}` : ''"
    aria-label="Progress"
  >
    <ol role="list">
      <li
        class="c-progress-step-bar__item"
        v-for="(step, index) in steps"
        :key="index"
        :class="stepState(index + 1)"
      >
        <div class="c-progress-step-bar__step">
          <span class="c-progress-step-bar__step-label">{{ step.label }}</span>
        </div>
        <div class="c-progress-step-bar__percentage">
          <div
            class="c-progress-step-bar__percentage-inner"
            :style="step.progress ? `width : ${step.progress}` : null"
          ></div>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
  export default {
    name: "ProgressStepBar",
    props: {
      currentStep: {
        type: Number,
        default: 0,
      },
      steps: {
        type: Array,
        required: true,
      },
      theme: {
        type: null | "light" | "dark" | "defult",
        required: false,
        default: null,
      },
    },
    methods: {
      stepState(step) {
        const stepClass = "c-progress-step-bar__item";
        return step === this.currentStep
          ? `${stepClass}--is-active`
          : step < this.currentStep
          ?  `${stepClass}--is-completed`
          : null
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/progress-step-bar/ProgressStepBar.vue